<template>
  <div class="">
    <div v-b-modal="`holoo-show-detail-${item.id}`" @click="loadHistory()"
         v-if="findAttributeOnSiteInfo('holoo_status')[0] == 1 && holooStatus" class="badge badge-secondary">
      وضعیت حسابداری:
      {{ holooStatus }}
    </div>


    <b-modal :id="`holoo-show-detail-${item.id}`" hide-footer>
      <div class="text-right" dir="rtl" v-if="item.holoo_history">
        <button class="btn btn-primary mx-1 " @click="sendItemManager(item.holoo_history)">ارسال مجدد</button>
        <button
          class="btn btn-primary mx-1 "
          v-if="item.holoo_history.historyable_type == 'product'"
          @click="fullUpdateProduct(item.holoo_history)"
        >بازخوانی</button>

        <div class="table-responsive">
          <table class="table table-striped text-center">
            <thead>
            <tr>
              <th>کدحسابداری</th>
              <th>تعداد تلاش</th>
              <th>ارسال پیامک خطا</th>
              <th>اطلاعات ارسالی</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td @click="copyData(holoo_history_item['holoo_code'])">{{ holoo_history_item['holoo_code'] }}</td>
              <td>{{ holoo_history_item['try_count'] }}</td>
              <td>{{ holoo_history_item['send_sms_try_count'] }}</td>
              <td>
                <b-icon class="mx-2 h5" icon="files" @click="copyData(holoo_history_item['data'])"/>
                <b-icon class="mx-2 h5" icon="eye" v-b-toggle="`code-collapse-${item.id}`"/>

              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <b-collapse :id="`code-collapse-${item.id}`" class="mt-2">
          <pre class="code-section-style rounded">
            {{ indentJson(holoo_history_item['data']) }}
          </pre>
        </b-collapse>

        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">وضعیت</th>
            <th scope="col">تاریخ انجام</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="logItem in historyLogs" :key="logItem.id || logItem.created_at">
            <td scope="row">{{ logItem.value }}</td>
            <td dir="ltr" scope="row">{{ dateConverter(logItem.created_at, '/', true, 'jalali') }}</td>
          </tr>
          </tbody>
        </table>
        <pagination400 :on-change-page="loadHistory" :meta="pagination"/>
      </div>
    </b-modal>

  </div>
</template>

<script>
import {holoo_history_status} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Holoo";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import Pagination400 from "../../../../miw-components/pagination/Pagination-400.vue";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "HolooStatus",
  components: {Pagination400},
  props: {
    item: {
      default: null
    }
  },
  data() {
    return {
      historyLogs: [],
      pagination: {},
    }
  },
  computed: {
    holoo_history_item() {
      if (this.item == null || this.item.holoo_history == null) {
        return false
      }
      return this.item.holoo_history
    },
    holooStatus() {
      if (this.item == null || this.item.holoo_history == null) {
        return false
      }
      let holoo_history = this.item.holoo_history

      return holoo_history_status[holoo_history.status]
    },

  },
  methods: {
    dateConverter,
    findAttributeOnSiteInfo,
    async loadHistory(page = 1) {
      if (!this.item || !this.item.holoo_history || !this.item.holoo_history.id) {
        return
      }
      let form = {
        page: page,
        id: this.item.holoo_history.id
      }
      let req = await this.$store.dispatch('Holoo/showLogsHolooHistory', form)
      let data = req.data.data;
      this.historyLogs = data.data
      this.pagination = data.meta
    },
    copyData(data) {
      navigator.clipboard.writeText(data).then(function () {
        toast('کپی با موفقیت انجام شد', 'کپی با موفقیت انجام شد')
      }, function (err) {
        console.log('Copy Error => ', err)
      })
    },
    indentJson(data) {
      try {
        const obj = JSON.parse(data);

        // دوباره تبدیل به متن با فاصله (indent)
        return JSON.stringify(obj, null, 2);
      } catch (error) {
        return ''
      }

    },
    sendItemManager(item) {
      if (!item) {
        return
      }
      if (item.historyable_type == 'order') {
        this.$store.dispatch('Holoo/retrySendOrder', {order_id: item.historyable_id}).then(res => {
          toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
        })
      }
      if (item.historyable_type == 'product') {
        this.$store.dispatch('Holoo/retrySendProduct', {holoo_history_id: item.id}).then(res => {
          toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
        })
      }
    },
    fullUpdateProduct(item){
      if (!item || !item.id) {
        return
      }
      this.$store.dispatch('Holoo/retrySendProductFull', {holoo_history_id: item.id}).then(res => {
        toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.code-section-style {
  direction: ltr;
  text-align: left;
  background: #1d1e22;
  color: white;
}
</style>